module.exports = __webpack_public_path__ + "school/img/ebooksCategoryItemBg.39129e0e.png";